module.exports = __webpack_public_path__ + "c16808d9384af0724c3ca1609fe25ad2.png";